
import {
  put, call, takeLatest,
} from 'redux-saga/effects';

import {
  MODALS, API_URLS, FETCH_OPTIONS, SUCCESS_MODALS,
} from '../constants';
import { requestGet, requestPost } from '../utils/request';
import { aGetGoldenGoalSettingsRequest, aUpdateGoldenGoalSettingsRequest } from '../reducers';
import { aSetIsFetching, aSetOpenModal } from '../reducers/common';
import { aGetGoldenGoalSettingsSuccess, aUpdateGoldenGoalSettingsSuccess } from '../reducers/goldenGoalSettings';

/**
 * @memberof sagas/goldenGoalSettings
 * @async
 */
function* getGoldenGoalSettingsSaga() {
  let response;
  try {
    yield put(aSetIsFetching({
      key: FETCH_OPTIONS.GET_GOLDEN_GOAL_SETTINGS,
      value: true,
    }));

    response = yield call(requestGet, API_URLS.GET_GOLDEN_GOAL_SETTINGS, true);

    if (response.status === -1) {
      throw Error(response.error.message);
    } else {
      yield put(aGetGoldenGoalSettingsSuccess({
        goldenGoalSettingsConfigurations: response.data?.goldenGoalConfigurations,
      }));
    }
    yield put(aSetIsFetching({
      key: FETCH_OPTIONS.GET_GOLDEN_GOAL_SETTINGS,
      value: false,
    }));
  } catch (error) {
    yield put(aSetOpenModal({
      modal: error.modal || MODALS.GENERAL_ERROR,
      errorMessage: error.modal ? error.message : MODALS.GENERAL_ERROR,
      key: FETCH_OPTIONS.GET_GOLDEN_GOAL_SETTINGS,
      value: false,
    }));
  }
}

/**
 * @param {object} action
 */
function* updateGoldenGoalSettingsSaga(action) {
  let response;
  try {
    yield put(aSetIsFetching({
      key: FETCH_OPTIONS.UPDATE_GOLDEN_GOAL_SETTINGS,
      value: true,
    }));
    response = yield call(requestPost, API_URLS.UPDATE_GOLDEN_GOAL_SETTINGS, action.payload, true);

    if (response.status === -1) {
      throw Error(response.error.message);
    } else {
      yield put(aUpdateGoldenGoalSettingsSuccess({
        goldenGoalConfigurations: response.data.goldenGoalConfigurations,
      }));

      yield put(aSetOpenModal({
        modal: MODALS.SUCCESS,
        modalData: {
          message: SUCCESS_MODALS.UPDATE_GOLDEN_GOAL_SETTINGS,
          additionalMessage: `${action.payload?.leagueName} updated successfully`,
          modal: SUCCESS_MODALS.UPDATE_GOLDEN_GOAL_SETTINGS,
        },
      }));

      yield put(aSetIsFetching({
        key: FETCH_OPTIONS.UPDATE_GOLDEN_GOAL_SETTINGS,
        value: false,
      }));
    }
  } catch (error) {
    yield put(aSetOpenModal({
      modal: error.modal || MODALS.GENERAL_ERROR,
      errorMessage: error.modal ? error.message : MODALS.GENERAL_ERROR,
      key: FETCH_OPTIONS.UPDATE_GOLDEN_GOAL_SETTINGS,
      value: false,
    }));
  }
}

/**
 * @memberof sagas/goldenGoalSettings
 * @async
 * @returns {void}
 */
export default function* goldenGoalSettingsSaga() {
  yield takeLatest(aGetGoldenGoalSettingsRequest, getGoldenGoalSettingsSaga);
  yield takeLatest(aUpdateGoldenGoalSettingsRequest, updateGoldenGoalSettingsSaga);
}

